module.exports = __webpack_public_path__ + "img/bubble3-active.276c255c.svg";